import {Color} from 'three';

export class Labels {
    private _assessments = {
        assessments1: {
            name: '2a',
            color: new Color(0.4, 0.6, 1)
        },
        assessments2: {
            name: '2b',
            color: new Color(0, 0.2, 0.6)
        },
        assessments3: {
            name: '3',
            color: new Color(1, 0.2, 0.2)
        },
        assessments4: {
            name: '4',
            color: new Color(0.2, 0.2, 0.2)
        },
        skin: {
            name: 'skin',
            color: new Color(1, 223 / 255, 214 / 255)
        },
    };

    constructor() {
    }

    get color2a() {
        return this._assessments.assessments1;
    }

    get color2b() {
        return this._assessments.assessments2;
    }

    get color3() {
        return this._assessments.assessments3;
    }

    get color4() {
        return this._assessments.assessments4;
    }

    get colorSkin() {
        return this._assessments.skin;
    }
}
